import { axiosSwagger } from "@/axios";

export const state = {
    trashFolder: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // TRASH FOLDER
    trashFolderLoading: (state, loading) => {
        state.trashFolder.loading = loading;
    },
    setTrashFolderData: (state, data) => {
        state.trashFolder.data = modifyData( data );
    },
    setTrashFolderTotal: (state, total) => {
        state.trashFolder.total = total;
    },
    removeTrashFolder: (state, id) => {
        state.trashFolder.data = state.trashFolder.data.filter(
            (el) => el.id !== id
        );
    },
    removeMultipleTrashFolder: (state, dataArr) => {
        state.trashFolder.data = state.trashFolder.data.filter(
          (el) => !dataArr?.includes(el.id)
        );
    }
}


export const actions = {
    // READ TRASH FOLDER
    async readTrashFolder({ commit }) {
        commit("trashFolderLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileFolder/Trash/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            commit("setTrashFolderData", response.data);
            commit("setTrashFolderTotal", response.data.length);
            commit("trashFolderLoading", false);

            return response;
        })
        .catch(() => {
            commit("trashFolderLoading", false);
        });
    },
    // RESTORE FOLDER
    async restoreFolder({ commit }, id) {
        return await axiosSwagger
            .put(`/api/FileFolder/Restore/${id}`)
            .then((response) => {
                commit("removeTrashFolder", id);
                return response;
            });
    },
    // DELETE FOLDER FOREVER
    async deleteFolderForever({ commit }, id) {
        return await axiosSwagger
            .post(`/api/FileFolder/Remove`, [{ id }])
            .then((response) => {
                commit("removeTrashFolder", id);
                return response;
            });
    },
    async multipleDeleteFolderForever({ commit }, data) {
        return await axiosSwagger
            .post(`/api/FileFolder/Remove`, data)
            .then((response) => {
                commit("removeMultipleTrashFolder", data.map(e => e.id));

                return response;
            });
    },
}



// modify data for totalFileSize
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
      arrayData.forEach(e => {
        e.totalFileSize = (e.fileManagers?.length ?? false) ? sum(e.fileManagers, 'totalFileSize') : 0;
      });
  
      return arrayData;
    }
  
    return [];
};
  
const sum = (array, key) => {
return array.reduce((accumulator, object) => {
    return accumulator + object[key];
}, 0);
}